var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAblageNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4388",
    "data-name": "Group 4388",
    transform: "translate(-6013 -6700)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(6013 6700)",
    fill: "#e8fcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(6032.117 6725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M168.81,287.2h57.354a4.414,4.414,0,0,1,4.412,4.412v29.411a4.413,4.413,0,0,1-4.412,4.412H173.223a4.413,4.413,0,0,1-4.412-4.412Z",
    transform: "translate(-168.81 -275.435)",
    fill: "#00c4de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M383.023,250.677h22.92a7.355,7.355,0,0,1,4.412,1.471,4.414,4.414,0,0,0-4.412-4.412H380.08Z",
    transform: "translate(-348.59 -241.853)",
    fill: "#5f5f5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M168.81,217.094v-4.412a4.412,4.412,0,0,1,4.412-4.412h15.211a4.405,4.405,0,0,1,3.119,1.293l7.532,7.531Z",
    transform: "translate(-168.81 -208.27)",
    fill: "#5f5f5f",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAblageNew);
export default __webpack_public_path__ + "static/media/ICON_Ablage_new.9e4a4cc86d09b8d5241b87b3b6b33779.svg";
export { ForwardRef as ReactComponent };